import { render, staticRenderFns } from "./CheckoutDonation.vue?vue&type=template&id=348af68c"
import script from "./CheckoutDonation.vue?vue&type=script&lang=ts"
export * from "./CheckoutDonation.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutDonation.vue?vue&type=style&index=0&id=348af68c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports